import axios from 'axios'
import {
  URL_USER,
  URL_SERVER,
  URL_PROVEEDOR,
  URL_LOGIN,
  URL_ORDENCOMPRA,
  URL_TRANSPORTE,
  URL_PRODUCTO,
  URL_VEHICULO_MARCA,
  URL_VEHICULO_MODELO,
  URL_CATEGORIA,
  URL_VEHICULOS,
  URL_FAMILIA,
  URL_MARCA_PRODUCTO,
  URL_CLASIFICACION_PRODUCTO,
  URL_PRODUCTO_MIRANDA,
  URL_CAJA,
  URL_VENDEDOR,
  URL_VOUCHER,
  URL_VENTA_VOUCHER,
  URL_PRODUCTO_VENTA,
  URL_SUCURSAL,
  URL_DEVOLUCIONES, URL_DTE, URL_POST_VENTA, URL_MOVIMIENTO, URL_ENCARGO,
} from "../api/config";
import {
  request, logout, auth_success, auth_error,
  proveedor_success, proveedor_error,
  orden_success, orden_error, producto_succes, producto_error
} from './mutations'
import makeQuery, {QueryMaker} from "../api/helper";
import moment from "moment";

export const actions = {
  login({commit}, user) {
    return new Promise((resolve, reject) => {
      commit('request')
      axios({url: URL_SERVER + URL_LOGIN, data: user, method: 'POST'})
        .then(resp => {
          const date = new Date();
          const endOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
          const expiration = "expires=" + endOfDay.toUTCString()
          const token = `Bearer ${resp.data.token}`
          const userToken = JSON.parse(window.atob(resp.data.token.split('.')[1]))
          document.cookie = `Token=${resp.data.token};${expiration}`
          localStorage.setItem('token', token)
          localStorage.setItem('refreshToken', resp.data.refresh_token)
          localStorage.setItem('user', JSON.stringify(userToken))
          localStorage.setItem('permissions', JSON.stringify(userToken.roles));
          localStorage.setItem('nombre', JSON.stringify(userToken.nombre).replaceAll('"', ""));
          localStorage.setItem('usuario_id', JSON.stringify(userToken.id).replaceAll('"', ""));
          axios.defaults.headers.common['Authorization'] = token
          commit('auth_success', token, user)
          resolve(resp)
        })
        .catch(error => {
          commit('auth_error')
          localStorage.removeItem('user')
          localStorage.removeItem('token')
          reject(error)
        })
    })
  },
  register({commit}, user) {
    return new Promise((resolve, reject) => {
      commit('request')
      axios({url: URL_SERVER + URL_USER, data: user, method: 'POST'})
        .then(resp => {
          const token = resp.data.token
          const user = resp.data.user
          localStorage.setItem('token', token)
          axios.defaults.headers.common['Authorization'] = token
          commit('auth_success', token, user)
          resolve(resp)
        })
        .catch(error => {
          commit('auth_error')
          reject(error)
        })
    })
  },

  logout({commit}) {
    return new Promise((resolve) => {
      commit('logout')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('username')
      localStorage.removeItem('pass')
      localStorage.removeItem('sucursal')
      localStorage.removeItem('usuario_id')
      localStorage.removeItem('nombre')
      localStorage.removeItem('sucursal_id')
      localStorage.removeItem('sidebar')
      localStorage.removeItem('permissions')
      document.cookie = `Token=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`
      delete axios.defaults.headers.common['Authorization']
      resolve()
    })
  },

  editarTransporte({commit}, transporte) {
    return new Promise((resolve) => {
      commit('request')
      axios({url: URL_SERVER + URL_TRANSPORTE, data: transporte, method: 'PUT'})
        .then(resp => {
          commit('transporte_success', transporte)
          resolve(resp)
        }).catch(error => {
        commit('transporte_error')
        console.log(error, 'error al modificar transporte')
      })
    })
  },
  editarProducto({commit}, producto) {
    return new Promise((resolve) => {
      commit('request')
      axios({url: URL_SERVER + URL_PRODUCTO, data: producto, method: 'PUT'})
        .then(resp => {
          commit('producto_success', producto)
          resolve(resp)
        }).catch(error => {
        commit('producto_error');
        console.log(error, 'error al modificar producto')
      })
    })
  },
  crearTransporte({commit}, transporte) {
    return new Promise((resolve, reject) => {
      commit('request');
      axios({url: URL_SERVER + URL_TRANSPORTE, data: transporte, method: 'POST'})
        .then(resp => {
          commit('transporte_success', transporte);
          resolve(resp)
        }).catch(error => {
        commit('transporte_error');
        console.log(error, 'error al crear transporte');
        reject(error)
      })
    })
  },
  crearProveedor({commit}, proveedor) {
    return new Promise((resolve, reject) => {
      commit('request')
      axios({url: URL_SERVER + URL_PROVEEDOR, data: proveedor, method: 'POST'})
        .then(resp => {
          const token = resp.data.token
          localStorage.setItem('token', token)
          axios.defaults.headers.common['Authorization'] = token
          commit('proveedor_success', token, proveedor)
          resolve(resp)
        })
        .catch(error => {
          commit('proveedor_error')
          reject(error)
        })
    })
  },
  crearOrdenCompra({commit}, ordenCompra) {
    return new Promise((resolve, reject) => {
      commit('request')
      axios({url: URL_SERVER + URL_ORDENCOMPRA, data: ordenCompra, method: 'POST'})
        .then(resp => {
          if (resp.status === 201) {
            commit('orden_success', ordenCompra)
            resolve(resp)
          }
        })
        .catch(error => {
          commit('orden_error')
          console.log(error)
          reject(error)
        })
    })
  },
  loadProveedores({commit}, nombre, rut, limite, offset) {
    const query = makeQuery({
      filtros: [
        {
          field: 'nombre',
          value: nombre || '',
          operator: 'CONTAINS'
        },
        {
          field: 'rut',
          value: rut || '',
          operator: 'CONTAINS'
        },
      ],
      limite: limite,
      offset: offset
    })
    axios.get(`${URL_SERVER + URL_PROVEEDOR}${query}`)
      .then(resp => {
        commit('SET_PROVEEDORES', resp.data.items.sort((a, b) => {
          if (a.nombre > b.nombre) {
            return 1;
          }
          if (a.nombre < b.nombre) {
            return -1;
          }
          // a must be equal to b
          return 0;
        }))
      })
      .catch((error) => {
        console.log(error, 'Error al obterner proveedores')
      })
  },
  loadUsuarios({commit}) {
    axios.get(URL_SERVER + URL_USER)
      .then(resp => {
        commit('SET_USUARIO', resp.data.items)
      }).catch(error => {
      console.log(error)
    })
  },
  loadTransporte({commit}) {
    axios.get(URL_SERVER + URL_TRANSPORTE)
      .then(resp => {
        commit('SET_TRANSPORTE', resp.data.items)
      }).catch(error => {
      console.log(error)
    })
  },
  loadProducto({commit}) {
    axios.get(URL_SERVER + URL_PRODUCTO)
      .then(resp => {
        commit('SET_PRODUCTO', resp.data.items)
      }).catch(error => {
      console.log(error)
    })
  },
  loadProductoMiranda({commit}) {
    axios.get(URL_SERVER + URL_PRODUCTO_MIRANDA)
      .then(resp => {
        commit('SET_PRODUCTO_MIRANDA', resp.data.items)
      })
      .catch(error => console.log(error))
  },
  loadProductoVenta({commit}) {
    axios.get(`${URL_SERVER + URL_PRODUCTO_VENTA}`)
      .then(resp => {
        commit('SET_PRODUCTO_VENTA', resp.data.items)
      })
      .catch(error => console.log(error))
  },
  loadOrdenCompra({commit}) {
    axios.get(`${URL_SERVER + URL_ORDENCOMPRA}`)
      .then((resp) => {
        commit('SET_ORDEN_COMPRA', resp.data.items)
      }).catch(error => console.log(error))
  },
  loadMarcas({commit}, marca, codigo, limite, offset, loading) {
    loading = true
    const query = makeQuery({
      filtros: [
        {
          field: 'nombre',
          value: marca || '',
          operator: 'CONTAINS'
        },
        {
          field: 'nombre',
          value: codigo || '',
          operator: 'CONTAINS'
        }
      ],
      limite: limite,
      offset: offset
    })
    axios.get(URL_SERVER + URL_VEHICULO_MARCA + query)
      .then(resp => {
        commit('SET_MARCA_VEHICULO', resp.data.items.filter(item => item.estado !== 'inactivo')
          .sort((a, b) => {
            if (a.nombre > b.nombre) {
              return 1;
            }
            if (a.nombre < b.nombre) {
              return -1;
            }
            // a must be equal to b
            return 0;
          }))
        loading = false
      })
      .catch(error => {
        loading = false
        console.log(error)
      })
  },
  loadModelo({commit}) {
    axios.get(URL_SERVER + URL_VEHICULO_MODELO)
      .then(resp => {
        commit('SET_VEHICULO_MODELO', resp.data.items)
      }).catch(error => console.log(error))
  },
  loadCategoria({commit}, categoria) {
    const query = makeQuery({
      filtros: [
        {
          field: 'nombre',
          value: categoria || '',
          operator: 'CONTAINS'
        }
      ]
    })
    axios.get(URL_SERVER + URL_CATEGORIA + query)
      .then(resp => {
        commit('SET_CATEGORIAS', resp.data.items.filter(item => item.estado !== 'inactivo')
          .sort((a, b) => {
            if (a.nombre > b.nombre) {
              return 1;
            }
            if (a.nombre < b.nombre) {
              return -1;
            }
            // a must be equal to b
            return 0;
          }))
        console.log(resp)
      }).catch(error => console.log(error))
  },
  loadFamilia({commit}) {
    axios.get(URL_SERVER + URL_FAMILIA)
      .then(resp => {
        commit('SET_FAMILIA', resp.data.items)
      }).catch(error => {
      console.log(error)
    })
  },
  loadMarcaProducto({commit}) {
    axios.get(URL_SERVER + URL_MARCA_PRODUCTO)
      .then(resp => {
        commit('SET_MARCA_PRODUCTO', resp.data.items.filter(item => item.estado !== 'inactivo')
          .sort((a, b) => {
            if (a.nombre > b.nombre) {
              return 1;
            }
            if (a.nombre < b.nombre) {
              return -1;
            }
            // a must be equal to b
            return 0;
          }))
      })
  },
  loadClasificacion({commit}) {
    axios.get(URL_SERVER + URL_CLASIFICACION_PRODUCTO)
      .then(resp => {
        commit('SET_CLASIFICACION_PRODUCTO', resp.data.items)
      })
  },
  loadVehiculos({commit}) {
    axios.get(`${URL_SERVER + URL_VEHICULOS}`)
      .then(resp => {
        commit('SET_VEHICULOS', resp.data.items)
      })
  },
  loadSucursal({commit}) {
    this._vm.$axios.get(`${URL_SUCURSAL}`)
      .then(resp => {
        commit('SET_SUCURSAL', resp.data.items.filter(item => item.estado !== 'inactivo'))
      })
      .catch(error => console.log(error))
  },
  loadVoucher({commit}, sucursal_id) {
    const query = makeQuery({
      filtros: [
        {field: 'estado', value: 'pendiente', operator: '='},
        {field: 'sucursal_id', value: window.localStorage.sucursal_id, operator: '='},
      ]
    })
    axios.get(`${URL_SERVER + URL_VENTA_VOUCHER}${query}`)
      .then(resp => {
        commit('SET_VOUCHER', resp.data.items
          // .filter(item =>
          //     item.sucursal_id === sucursal_id
          //     && item.estado !== 'pagado'
          //     && item.estado !== 'anulada')
          .sort((a, b) => b.folio - a.folio))
      })
      .catch(error => console.log(error))
  },

  loadBoletas({commit}, caja_id) {
    const query = makeQuery({
      filtros: [
        {field: 'caja_id', value: caja_id, operator: '='}
      ]
    })
    axios.get(`${URL_SERVER + URL_DTE}/boleta${query}&ordenar_por=folio&orden=desc`)
      .then(({data}) => {
        commit('SET_BOLETAS', data.items)
      })
      .catch(e => console.log(e))
  },
  loadFacturas({commit}, caja_id) {
    const query = makeQuery({
      filtros: [
        {field: 'caja_id', value: caja_id, operator: '='}
      ]
    })
    axios.get(`${URL_SERVER + URL_DTE}/factura${query}&ordenar_por=folio&orden=desc`)
      .then(({data}) => {
        commit('SET_FACTURAS', data.items)
      })
      .catch(e => console.log(e))
  },
  loadEncargos({commit}, caja_id) {
    const query = makeQuery({
      filtros: [
        {field: 'caja_id', value: caja_id, operator: '='}
      ]
    })
    axios.get(`${URL_SERVER + URL_DTE}/encargo${query}&ordenar_por=folio&orden=desc`)
      .then(({data}) => {
        console.log(data.items, 'encargo')
        commit('SET_ENCARGO', data.items)
      })
      .catch(e => console.log(e))
  },
  loadSaldosFavor({ commit }, caja_id) {
    const query = new QueryMaker(1)
      .eq('caja_id', caja_id).toString()
    axios.get(URL_SERVER + 'caja/saldo-favor' + query)
      .then(({ data }) => commit('SET_SALDOS_FAVOR', data.items))
      .catch(e => console.log(e))
  },
  loadIngresos({commit}, caja_id) {
    const query = makeQuery({
      filtros: [
        {field: 'caja_id', value: caja_id, operator: '='},
        {field: 'tipo_movimiento', value: 'ingreso', operator: '='},
      ]
    })
    axios.get(`${URL_SERVER + URL_MOVIMIENTO + query}`)
      .then(({data}) => {
        commit('SET_INGRESOS', data.items)
      }).catch(e => console.log(e))
  },
  loadNotasCredito({commit}) {
    axios.get(`${URL_SERVER + URL_POST_VENTA}`)
      .then(({data}) => {
        commit('SET_NOTA_CREDITO', data.items
          .sort((a, b) => b.folio_dcto_devolucion - a.folio_dcto_devolucion))
      }).catch(e => console.log(e))
  },
  isToggleWithoutAnimation({commit}, value) {
    commit('TOGGLE_WITHOUT_ANIMATION', value)
  }
}


// 14-03-2020 CREACION
// 14-03-2020 APERTURA
